import { BrokerExtensions } from "@primaria/plugins-core";
import { BrokerDisposableHandler } from "@uxland/primary-shell";
import { AddUpFiltersHandler } from "./handler";
import { AddUpFiltersCommand } from "./request";

let request: BrokerDisposableHandler;

export const bootstrapAddUpFilter = (broker: BrokerExtensions) => {
  request = broker.registerRequest(AddUpFiltersCommand, AddUpFiltersHandler);
};

export const teardownAddUpFilter = () => {
  request?.dispose();
};
